import ecommerceImg from "../assets/ecommercee.webp"; // Replace with your actual image path
import { useNavigate } from 'react-router-dom'; 
import { motion } from "framer-motion";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { Helmet } from "react-helmet";

import { toast, ToastContainer } from "react-toastify";

import { useRef,useEffect,useState } from "react";
import buildingIcon from "../assets/building-icon.png";
import recommendationsGroup from "../assets/recommendations.png";
import visualSearchGroup from "../assets/upload-icon.png";
import chatbotGroup from "../assets/chatbot-icon.png";
import sliderGroup from "../assets/slider-icon.png";

const ScrollingWordsSection = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
              // const [isServicesOpen, setIsServicesOpen] = useState(false);
              // const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
              // const [isCompanyOpen, setIsCompanyOpen] = useState(false);
            
              const toggleMobileMenu = () => {
                setIsMobileMenuOpen(!isMobileMenuOpen);
              };
            
              // const toggleServicesDropdown = () => {
              //   setIsServicesOpen(!isServicesOpen);
              // };
            
              // const toggleIndustriesDropdown = () => {
              //   setIsIndustriesOpen(!isIndustriesOpen);
              // };
            
              // const toggleCompanyDropdown = () => {
              //   setIsCompanyOpen(!isCompanyOpen);
              // };
        const [data, setData] = useState("");
          const [sessionid, setSessionid] = useState("");
          const [email, setEmail] = useState("");
          const [token, setToken] = useState("");
          useEffect(() => {
            fetch("https://api.app.mawalog.com/v1.2/website")
              .then((response) => response.json())
              .then((json) => {
                setData(json.data.captcha_code);
                setSessionid(json.data.session_id);
                setToken(json.data.token);
              })
              .catch((error) => console.error("Error fetching data:", error));
          }, []);
          useEffect(() => {
            const canvas = document.getElementById("captchaCanvas");
            if (canvas) {
              const ctx = canvas.getContext("2d");
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              ctx.font = "bold 18px Arial";
              ctx.fillStyle = "#00377B";
              ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
            }
          }, [data]);
          const handleChange = (e) => {
            setEmail(e.target.value);
          };
         
           const canvasRef = useRef(null);
          const [captchaValue, setCaptchaValue] = useState(""); // text from API
          const [userCaptcha, setUserCaptcha] = useState("");
         
            /* ------------------------------------------------------------------- API fetch */
          const fetchCaptcha = async () => {
            try {
              const res = await fetch(
                "https://api.app.mawalog.com/v1.2/website"
              );
              const json = await res.json();
              setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
            } catch (err) {
              console.error("Error fetching captcha:", err);
            }
          };
         
          /* -- fetch once on mount ------------------------------------------------------- */
          useEffect(() => {
            fetchCaptcha();
          }, []);
         
          /* -- redraw every time captchaValue changes ------------------------------------ */
          useEffect(() => {
            if (!data) return; // nothing to paint yet
            const canvas = canvasRef.current;
            if (!canvas) return;
         
            const ctx = canvas.getContext("2d");
            const W = canvas.width;
            const H = canvas.height;
         
            /* ========= clear & background */
            ctx.clearRect(0, 0, W, H);
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, W, H);
         
            /* ========= random faint bezier curves (extra distortion) */
            for (let i = 0; i < 3; i++) {
              ctx.beginPath();
              ctx.moveTo(Math.random() * W, Math.random() * H);
              ctx.bezierCurveTo(
                Math.random() * W,
                Math.random() * H,
                Math.random() * W,
                Math.random() * H,
                Math.random() * W,
                Math.random() * H
              );
              ctx.lineWidth = 1 + Math.random(); // 1-2 px
              ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
              ctx.stroke();
            }
         
            /* ========= characters (uneven) */
            ctx.font = "bold 22px Arial";
            ctx.fillStyle = "#0A3A72";
            const chars = data.toString().split("");
         
            chars.forEach((ch, i) => {
              const angle = (Math.random() - 0.5) * 0.8; // ±23°
              const x = 8 + i * 14 + (Math.random() * 4 - 2);
              const y = 22 + (Math.random() * 6 - 3);
         
              ctx.save();
              ctx.translate(x, y);
              ctx.rotate(angle);
              ctx.fillText(ch, 0, 0);
              ctx.restore();
            });
         
            /* ========= dots */
            for (let i = 0; i < 45; i++) {
              ctx.beginPath();
              ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
              ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
              ctx.fill();
            }
          }, [data]);
         
          /* -- reload button click ------------------------------------------------------- */
          // const handleReload = () => {
          //   fetch("https://api.app.mawalog.com/v1.2/website")
          //     .then((response) => response.json())
          //     .then((json) => {
          //       setData(json.data.captcha_code);
          //       setSessionid(json.data.session_id);
          //       setToken(json.data.token);
          //     })
          //     .catch((error) => console.error("Error fetching data:", error));
          // };
          //   const handleSubscribe = async () => {
          //   try {
          //     const response = await fetch(
          //       "https://api.app.mawalog.com/v1.2/newsletter",
          //       {
          //         method: "POST",
          //         headers: {
          //           "Content-Type": "application/json",
          //           "X-CSRF-TOKEN": token,
          //         },
          //         body: JSON.stringify({
          //           session_id: sessionid,
          //           captcha: userCaptcha,
          //           email: email,
          //           type: "Mawalog",
          //         }),
          //       }
          //     );
         
          //     const result = await response.json();
          //     console.log("Response:", userCaptcha, " ", data);
          //     setEmail("");
          //    setUserCaptcha("");
          //     toast(result.message);
          //   } catch (error) {
          //     console.error("Error sending request:", error);
          //   }
          // };
          const [openDropdown, setOpenDropdown] = useState(null);
          const navRef = useRef(null);
        
          // Close dropdown on outside click
          useEffect(() => {
            const handleClickOutside = (event) => {
              if (navRef.current && !navRef.current.contains(event.target)) {
                setOpenDropdown(null);
              }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
          }, []);
        
          const toggleDropdown = (dropdown) => {
            setOpenDropdown(openDropdown === dropdown ? null : dropdown);
          };
          
          const navigate = useNavigate();
         
          const handleClick = () => {
            navigate("/Contact#contact-section");
          };
            const [isOpen, setIsOpen] = useState(false);
                  
                    // const toggleDropdown = () => {
                    //   setIsOpen((prev) => !prev);
                    // };
              
              
                    const [isServicesOpen, setIsServicesOpen] = useState(false);
                const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
                const [isCompanyOpen, setIsCompanyOpen] = useState(false);
              
                // Toggle functions for dropdowns
                const toggleServicesDropdown = () => {
                  setIsServicesOpen(!isServicesOpen);
                  setIsIndustriesOpen(false);
                  setIsCompanyOpen(false); // Close other dropdowns
                };
              
                const toggleIndustriesDropdown = () => {
                  setIsIndustriesOpen(!isIndustriesOpen);
                  setIsServicesOpen(false);
                  setIsCompanyOpen(false); // Close other dropdowns
                };
              
                const toggleCompanyDropdown = () => {
                  setIsCompanyOpen(!isCompanyOpen);
                  setIsServicesOpen(false);
                  setIsIndustriesOpen(false); // Close other dropdowns
                };
                    const [word, setWord] = useState('Today');
              
                useEffect(() => {
                  const interval = setInterval(() => {
                    setWord((prev) => (prev === 'Today' ? 'Tomorrow' : 'Today'));
                  }, 2000);
                  return () => clearInterval(interval);
                }, []);
                 const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

      return (
    <>
  
<Helmet>
        <title>AI-Powered E-Commerce Platform | Personalized Shopping & Smart Solutions</title>
        <meta name="description" content="Transform your shopping experience with LENTERA’s AI-powered e-commerce platform. Enjoy personalized recommendations, visual search, AI chat support, dynamic pricing, smart inventory alerts, and secure, seamless transactions."/>
        <meta name="keywords" content="LENTERA e-commerce solutions, AI-driven shopping platform, real-time stock alerts, fraud detection in e-commerce, intelligent shopping assistant."/>
      </Helmet>


<section className="w-full bg-[#FFF6DA] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">

    {/* LEFT CONTENT */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <p className="text-[#212129] font-semibold text-sm mb-3 uppercase tracking-wider">
        E-Commerce
      </p>
      <h1 className="text-[#212129] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
        Smarter Shopping <br className="hidden lg:block" />
        personalized for You.
      </h1>
      <p className="text-[#212129] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
        Experience an AI-powered e-commerce platform that understands your taste, predicts your needs, and delivers faster.
      </p>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center lg:justify-end"
      initial={{ opacity: 0, scale: 0.9 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
    >
      <img src={ecommerceImg} alt="Ecommerce Illustration" className="w-[380px] sm:w-[460px] md:w-[520px] lg:w-full max-w-[600px] h-auto object-contain" />
    </motion.div>
  </div>
</section>


{/* WHY AI SECTION */}
<section className="bg-white py-20 px-4 sm:px-6 lg:px-12">
  <motion.div 
    className="max-w-[1300px] mx-auto bg-[#F8F8F8] rounded-t-[40px] px-6 sm:px-10 py-16"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7 }}
    viewport={{ once: true }}
  >
    {/* Header */}
    <div className="text-center mb-12">
      <span className="inline-block bg-[#E0E0E0] text-[#1A1A1A] text-sm font-medium px-4 py-1 rounded-full mb-4">
        AI IN E-COMMERCE
      </span>
      <h2 className="text-[32px] sm:text-[40px] md:text-[48px] font-extrabold text-[#1A1A1A] mb-4">
        Why AI with E-Commerce?
      </h2>
      <p className="text-[#4B4B4B] text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
        Our AI transforms your shopping journey with intelligent recommendations,
        faster search, and a highly personalized experience.
      </p>
    </div>

    {/* Cards Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-end">
      {[...Array(4)].map((_, idx) => (
        <motion.div
          key={idx}
          className={`rounded-t-[40px] p-6 flex flex-col justify-between ${
            idx === 0 ? "bg-[#FEB9CE]" :
            idx === 1 ? "bg-[#CBD5D4]" :
            idx === 2 ? "bg-[#E5DCD2]" : "bg-[#FFC931]"
          }`}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: idx * 0.2 }}
          viewport={{ once: true }}
        >
          <div>
            <h3 className="font-bold text-lg text-[#1A1A1A] mb-2 leading-snug">
              {idx === 0 && <>Personalized <br /> recommendations</>}
              {idx === 1 && <>Visual search <br /> integration</>}
              {idx === 2 && <>AI Chat <br /> assistant 24/7</>}
              {idx === 3 && <>Dynamic Pricing <br /> Engine</>}
            </h3>
            <p className="text-sm text-[#3F3F3F]">
              {idx === 0 && "Shop smarter with AI suggestions tailored to your style and shopping behavior."}
              {idx === 1 && "Upload a photo — find matching products instantly with AI image recognition."}
              {idx === 2 && "Get instant answers, product help, and order support with our smart chatbot."}
              {idx === 3 && "AI adjusts prices for the best deals based on trends, demand, and your preferences."}
            </p>
          </div>
          <img
            src={
              idx === 0 ? recommendationsGroup :
              idx === 1 ? visualSearchGroup :
              idx === 2 ? chatbotGroup :
              sliderGroup
            }
            alt="Feature Illustration"
            className="mt-6 w-full"
          />
        </motion.div>
      ))}
    </div>
  </motion.div>
</section>


{/* HOW IT WORKS SECTION */}
<section className="w-full">
  <motion.div 
    className="bg-[#262626] px-4 md:px-12 py-14 lg:py-20"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
  >
    <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-start justify-between gap-8">
      <div className="flex-1">
        <div className="inline-block bg-[#4A4A4A] text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6">
          HOW IT WORKS
        </div>
        <h2 className="text-white text-[28px] sm:text-[30px] lg:text-[50px] font-bold leading-tight">
          AI That Learns With You
        </h2>
      </div>
      <div className="flex-2 text-white text-base sm:text-lg leading-relaxed pt-4 lg:pt-10">
        Our AI evolves with every interaction to deliver smarter, <br />
        more personalized shopping every time.
      </div>
    </div>
  </motion.div>

  <div className="grid grid-cols-1 md:grid-cols-3">
    {["#FFE05E", "#FFE0FB", "#A3DCFF"].map((color, i) => (
      <motion.div
        key={i}
        className={`p-10 sm:p-12 lg:p-16 flex flex-col justify-start gap-6`}
        style={{ backgroundColor: color }}
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: i * 0.2 }}
        viewport={{ once: true }}
      >
        <img src={buildingIcon} alt="Icon" className="w-[50px] h-auto" />
        <h3 className="text-xl sm:text-2xl font-semibold text-[#262626]">
          {i === 0 ? "Browse Freely" : i === 1 ? "Get Smarter Results" : "Enjoy Seamless Support"}
        </h3>
        <p className="text-[#262626] text-base sm:text-lg">
          {i === 0 ? "Our AI observes your likes, searches & clicks." : i === 1 ? "The more you shop, the better it gets." : "Real-time help, tracking, and solutions via our smart assistant."}
        </p>
      </motion.div>
    ))}
  </div>
</section>


{/* AI FEATURES SECTION */}
<section className="bg-[#F9F9F9] py-20 px-4 sm:px-6 lg:px-12">
  <motion.div
    className="max-w-[1250px] mx-auto"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7 }}
    viewport={{ once: true }}
  >
    {/* Top Section */}
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 mb-12">
      <div>
        <span className="inline-block bg-[#E0E0E0] text-[#1A1A1A] text-sm font-medium px-4 py-1 rounded-full mb-4">
          AI FEATURES
        </span>
        <h2 className="text-[30px] sm:text-[36px] md:text-[42px] lg:text-[48px] font-extrabold text-gray-900 leading-tight">
          Smart Features <br />
          Powered by AI
        </h2>
      </div>
      <p className="text-gray-700 text-base md:text-lg max-w-md">
        Experience intelligent tools that personalize, predict, and enhance every step of your shopping journey.
      </p>
    </div>

    {/* Feature Cards */}
    <div className="bg-white rounded-[36px] shadow-md p-6 sm:p-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
      {/* Left Box */}
      <motion.div
        className="lg:col-span-4 flex flex-col justify-center"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">
          Additional features
        </h3>
        <p className="text-base text-gray-600">
          Built to deliver performance, reliability, and an exceptional user experience at every touchpoint.
        </p>
      </motion.div>

      {/* Right Cards */}
      <div className="lg:col-span-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className={`rounded-2xl p-6 ${
              i === 0 ? "bg-[#E9DDFD]" : i === 1 ? "bg-[#DDF2DB]" : "bg-[#E8E8E8]"
            }`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.2 }}
            viewport={{ once: true }}
          >
            <h4 className="text-md font-semibold text-gray-900 mb-2">
              {i === 0
                ? "Auto reorder suggestions"
                : i === 1
                ? "Fraud detection & Smart security"
                : "Smart inventory & Restock alerts"}
            </h4>
            <p className="text-sm text-gray-800">
              {i === 0
                ? "Regular buyers get smart refill reminders for frequently purchased items — never run out again!"
                : i === 1
                ? "AI monitors unusual activity to ensure secure and seamless transactions."
                : "Real-time stock tracking with intelligent alerts when your favorite products are back."}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  </motion.div>
</section>

            <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
  <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
            </>
  );
};

export default ScrollingWordsSection;
